/* eslint no-use-before-define: 0 */
import Script from 'next/script';

import { getDeviceAdId } from '@/utils/getDeviceAdId';

import { Keys, NetworkCallback, NetworkStatus, System } from '../index';

function registeredKeys() {
  return {
    UP: 38,
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    OK: 13,
    BACK: 8,
    SELECT: 13,
  };
}

let networkStatusInterval: number;

export const system: System = {
  id: 'hisense',
  init: () => {
    console.log('Hisense System');
  },
  version: () => 'hisense.1.0.0',
  script: () => {
    return (
      <Script
        strategy="beforeInteractive"
        src="https://tvmodules-vidaa.vidaahub.com/deviceapi/vidaatv.js?from=1196103339"
      />
    );
  },
  keyThrottleDelay: 100,
  key: (keyboardEvent) => {
    const deviceKeys = registeredKeys();
    switch (keyboardEvent.keyCode) {
      case deviceKeys.UP:
        return Keys.UP;
      case deviceKeys.DOWN:
        return Keys.DOWN;
      case deviceKeys.LEFT:
        return Keys.LEFT;
      case deviceKeys.RIGHT:
        return Keys.RIGHT;
      case deviceKeys.OK:
        return Keys.OK;
      case deviceKeys.SELECT:
        return Keys.OK;
      case deviceKeys.BACK:
        return Keys.BACK;
      default:
        return Keys.UNKNOWN;
    }
  },

  getDeviceId: async () => {
    //@ts-ignore
    return typeof Hisense_GetDeviceID === 'function' && Hisense_GetDeviceID();
  },

  getErrorCodePrefix: () => 'C',
  closeApp: () => {
    (window as any)?.close();
  },
  getDeviceAdId: async () => {
    return getDeviceAdId();
  },
  getAdIdType: async () => {
    return 'vaid';
  },
  getIsLimitedAdTracking: async () => {
    // TODO: Determine if Hisense ad tracking is enabled
    return true;
  },
  monitorConnectionStatus: (callback: NetworkCallback) => {
    let statusFunction;

    //@ts-ignore
    if (typeof Hisense_GetNetStatus === 'function') {
      //@ts-ignore
      statusFunction = Hisense_GetNetStatus;
    } else if (typeof (window as any)?.vidaatv?.getNetStatus === 'function') {
      statusFunction = (window as any)?.vidaatv?.getNetStatus;
    }

    if (statusFunction) {
      const networkStatusInterval = window.setInterval(() => {
        const status = statusFunction();

        callback(status);
      }, 10000);

      return () => {
        clearInterval(networkStatusInterval);
      };
    } else {
      const onOffline = () => {
        callback(false);
      };
      const onOnline = () => {
        callback(true);
      };

      window.addEventListener('offline', onOffline);
      window.addEventListener('online', onOnline);
      return () => {
        window.removeEventListener('offline', onOffline);
        window.removeEventListener('online', onOnline);
      };
    }
  },
  hasPointer: false,
  overrideAria: isTTSEnabled(),
};

/*
  Check if TTS is enabled on the TV or not
*/
function isTTSEnabled() {
  try {
    //@ts-ignore
    if (typeof Hisense_GetTTSEnable === 'function') return Hisense_GetTTSEnable();
  } catch (e) {
    return false;
  }
}
